import { MisEntry, MisField } from "../../interfaces/ActionStartResponse";
import MisFieldInput from "../MIS/MisFieldInput";
import { iEnquiryPropertiesProps } from "./EnquiryPropertiesModal";
import "./index.scss";

function DisplayRow({ field }: { field: MisField }) {
    if (field.fieldType === "DisplayTitle") {
        return (
            <div className="row rowMarginControl">
                <div className="col-sm-12">
                    <h6 className="font-bold">{field.label}</h6>
                </div>
            </div>
        );
    }
    return <hr />;
}

function isDisplayOnly(field: MisField): boolean {
    return (
        field.fieldType === "DisplayTitle" || field.fieldType === "DisplayGap" || field.fieldType === "DisplayDivider"
    );
}

export default function MIS(props: iEnquiryPropertiesProps) {
    const { enquiryDetails, updateRestricted, handleMisChange } = props;
    const fields = enquiryDetails?.misModel?.fields ?? [];
    const entries = enquiryDetails?.misData ?? [];
    const editable = !updateRestricted && handleMisChange !== undefined;

    function getValue(field: MisField): string {
        const entry = entries.find(e => e.fieldID === field.id);
        if (!entry || !entry.value) return field.defaultValue ?? "";

        if (field.fieldType === "Dropdown" || field.fieldType === "TextWithDropdown") {
            const lookup = field.lookupValues?.find(l => l.id.toString() === entry.value);
            return lookup ? lookup.name : entry.value;
        }
        if (field.fieldType === "Checkbox") {
            return entry.value === "1" ? "Yes" : "No";
        }
        return entry.value;
    }

    function getEntry(field: MisField): MisEntry {
        // A field that was never captured shows its default; an entry that exists keeps its own value, even if empty.
        return entries.find(e => e.fieldID === field.id) ?? { fieldID: field.id, value: field.defaultValue ?? "" };
    }

    return (
        <div>
            {fields.map(field => {
                if (isDisplayOnly(field)) {
                    return (
                        <DisplayRow
                            key={"mis-field-" + field.id}
                            field={field}
                        />
                    );
                }

                if (editable) {
                    return (
                        <MisFieldInput
                            key={"mis-field-" + field.id}
                            field={field}
                            entry={getEntry(field)}
                            onChange={handleMisChange}
                            enableDatePicker
                            firstCol={5}
                        />
                    );
                }

                return (
                    <div
                        className="row rowMarginControl"
                        key={"mis-field-" + field.id}
                    >
                        <div className="col-sm-4">
                            <label
                                className="g-label mis-field-label"
                                title={field.label}
                            >
                                {field.label}
                            </label>
                        </div>
                        <div className="col-sm-8">
                            <label className="g-label">{getValue(field)}</label>
                        </div>
                    </div>
                );
            })}
        </div>
    );
}
